import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import { FlexBox, Icon, Timestamp } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { ConversationStatusIcon } from '../../../conversation/components/conversationStatusIcon';
import styles from './notificationHistoryItem.module.scss';
export const NotificationHistoryItem = ({ notification, className, }) => {
    const { conversation, status } = notification;
    let icon;
    let customTitle = '';
    const fixedIconName = notification.icon
        ? notification.icon.replace(/^(i-)/, '')
        : notification.icon;
    const rootClass = classnames({
        [styles.root]: styles.root,
        [styles.rootSuccess]: status === 'success',
        [styles.rootWarning]: status === 'warning',
        [styles.rootDanger]: status === 'danger',
    }, className);
    if (notification.icon) {
        icon = _jsx(Icon, { name: fixedIconName, size: 24 });
    }
    if (notification.type === 'rating-up') {
        customTitle = 'Positive rating';
        icon = _jsx(DixaIcon, { className: 'circled bg-brand-b-0', icon: 'thumbs-up' });
    }
    else if (notification.type === 'rating-down') {
        customTitle = 'Negative rating';
        icon = _jsx(DixaIcon, { className: 'circled bg-brand-c-0', icon: 'thumbs-down' });
    }
    return (_jsxs(FlexBox, Object.assign({ className: rootClass }, { children: [_jsx(FlexBox, Object.assign({ alignItems: "center", justifyContent: "center", margin: "0 300 0 0", className: styles.icon }, { children: conversation ? (_jsx(ConversationStatusIcon, { channel: conversation.channel, direction: conversation.direction, status: conversation.status, className: "notification-item__icon" })) : (_jsx(_Fragment, { children: icon })) })), _jsx(FlexBox, { children: _jsxs("div", { children: [_jsx("h4", Object.assign({ className: styles.title }, { children: customTitle ? customTitle : notification.title })), _jsx("h6", Object.assign({ className: styles.time }, { children: _jsx(Timestamp, { time: notification.date }) }))] }) })] })));
};
